// extracted by mini-css-extract-plugin
export var cookies = "cookies-module--cookies--2jzvx";
export var inner = "cookies-module--inner--1yXrj";
export var content = "cookies-module--content--1hcej";
export var img = "cookies-module--img--2A1aU";
export var link = "cookies-module--link--2a0_4";
export var btns = "cookies-module--btns--fZwMe";
export var text = "cookies-module--text--20dDK";